var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categorie"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Brands / Restaurants'))+" > "+_vm._s(_vm.$t('Restaurants'))+" > "+_vm._s(_vm.$t('Add')))])]),_c('div',{staticClass:"page-content"},[_c('RestaurantsForm',{on:{"action":_vm.addRestaurants}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }